<template>
  <div class="payout-trans-details">
    <div class="filter-section-container">
      <div class="filter-fixed">
        <span class="filter-fixed-title">{{ $t('data.filter_section') }}</span>
        <i
          class="el-icon-arrow-down filter-fixed-arrow"
          :class="{'fiter-icon-arrow-route':!showFilterContent}"
          @click="onClickFixedArrow"
        />
      </div>
      <el-collapse-transition>
        <div v-show="showFilterContent">
          <div id="filter-content" class="filter-content">
            <div class="filter-item">
              <div class="filter-item-label">{{ $t('merchantAccount.create_time') }}</div>
              <el-date-picker
                v-model="search.createTimes"
                class="filter-item-value"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00','23:59:59']"
                type="daterange"
                range-separator="~"
                :start-placeholder="$t('components.start_date')"
                :end-placeholder="$t('components.end_date')"
              />
            </div>
            <div class="filter-item">
              <div class="filter-item-label">{{ $t('merchantAccount.complete_time') }}</div>
              <el-date-picker
                v-model="search.complete_times"
                class="filter-item-value"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00','23:59:59']"
                type="daterange"
                range-separator="~"
                :start-placeholder="$t('components.start_date')"
                :end-placeholder="$t('components.end_date')"
              />
            </div>
            <div class="filter-item">
              <div class="filter-item-label">{{ $t('components.status') }}</div>
              <el-select v-model="search.status" class="filter-item-value" size="small" clearable>
                <el-option
                  v-for="(item,index) in fxTransactionStatusMap"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
            <div class="filter-item">
              <div class="filter-item-label">{{ $t('data.buy_currency') }}</div>
              <el-select v-model="search.buy_currency" class="filter-item-value" size="small" clearable>
                <el-option
                  v-for="(item,index) in ['MYR', 'USD', 'IDR']"
                  :key="index"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </div>
            <div class="filter-item">
              <div class="filter-item-label">{{ $t('data.sell_currency') }}</div>
              <el-select v-model="search.sell_currency" class="filter-item-value" size="small" clearable>
                <el-option
                  v-for="(item,index) in ['USD', 'THB', 'IDR']"
                  :key="index"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </div>
            <div class="filter-item">
              <div class="filter-item-label">{{ $t('customerService.transaction_id') }}</div>
              <el-input v-model="search.transaction_id" size="small" type="text" class="filter-item-value" clearable />
            </div>
            <div class="filter-item" />
            <div class="filter-item" />
          </div>
          <div class="filter-operate">
            <div class="filter-operate-left">
              <el-button class="mb-10 download-btn" :loading="downloading" type="info" size="small" icon="el-icon-download" @click="onClickDowmloadBtn">{{ $t('components.download') }}</el-button>
            </div>
            <div class="filter-operate-right">
              <el-button class="search-btn mb-10" size="small" @click="onClickReset">{{ $t('components.clear') }}</el-button>
              <el-button class="search-btn mb-10" type="primary" size="small" icon="el-icon-search" @click="handleFilter">{{ $t('components.search') }}</el-button>
            </div>

          </div>
        </div>

      </el-collapse-transition>
    </div>

    <div class="tableContainer">
      <!-- 列表 -->
      <el-table
        v-loading="listLoading"
        :data="tableData"
        stripe
        fit
        highlight-current-row
        style="width: 100%"
      >

        <el-table-column :label="$t('customerService.transaction_id')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.transaction_id }}</span>
          </template>
        </el-table-column>


        <el-table-column :label="$t('data.sell_amount')" align="center">
          <template slot-scope="scope">
            <span> {{ scope.row.sell_amount | toDivideWithDot }} {{ scope.row.sell_currency}} </span>
          </template>
        </el-table-column>


        <el-table-column :label="$t('data.buy_amount')" align="center">
          <template slot-scope="scope">
            <span> {{ scope.row.buy_amount | toDivideWithDot }} {{ scope.row.buy_currency }} </span>
          </template>
        </el-table-column>


        <el-table-column :label="$t('data.exchange_rate')" align="center">
          <template slot-scope="scope">
            <span> {{ scope.row.exchange_rate }}</span>
          </template>
        </el-table-column>


        <el-table-column :label="$t('merchant.service_fee')" align="center">
            <template slot-scope="scope">
              <span>{{  scope.row.foreign_exchange_fee_split | toDivideWithDot }} {{ scope.row.foreign_exchange_fee_split_currency  }} </span>
            </template>
          </el-table-column>


        <el-table-column :label="$t('merchantAccount.po_trans_status')" align="center">
          <template slot-scope="scope">
            <el-tag class="tag-custom" :type="getFxTransactionStatusMap(scope.row.status).type">{{ getFxTransactionStatusMap(scope.row.status).label }}</el-tag>
          </template>
        </el-table-column>

        <!-- <el-table-column :label="$t('data.fx_transaction_type')" align="center">
          <template slot-scope="scope">
            <el-tag class="tag-custom" :type="getFXTransactionType(scope.row.exchange_type).type">{{ getFXTransactionType(scope.row.exchange_type).label }}</el-tag>
          </template>
        </el-table-column> -->



        <el-table-column :label="$t('merchantAccount.create_time')" align="center" width="105">
          <template slot-scope="scope">
            <span>{{ scope.row.create_date_time }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.complete_time')" align="center" width="105">
          <template slot-scope="scope">
            <span>{{ scope.row.complete_date_time }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('components.operation')" align="center">
          <template slot-scope="scope">
            <el-tooltip placement="top">
              <div slot="content">
                <span> {{ $t('components.detail') }}</span> <br>
              </div>
              <svg-icon class-name="icon-function" icon-class="operation-detail" @click="onClickDetailTxt(scope.row)" />
            </el-tooltip>
          </template>
        </el-table-column>

      </el-table>

      <div class="pagination-container">
        <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="onClickPaginator" />
      </div>
    </div>
    <FXDetailsModal ref="fxMentDetailsModal" :detail-id="detailId" />
  </div>
</template>

<script>

import { pageForeignExchange, pageForeignExchangeDownload } from '@/api/settlement/settlement'

import { fxTransactionStatusMap, fxTransactionTypeMap } from '@/utils/maps'
import { filterEmptyAttr, exportXlsx } from '@/utils/common'

import { appointDate } from '@/utils/index.js'
export default {
  name: 'Payout_Trans_Details',
  components: {
    Paginator: () => import('@/views/components/Paginator'),
    FXDetailsModal: () => import('./Modal/FXDetailsModal')
  },
  data() {
    return {
      showFilterContent: true,
      search: {
        status: null, // 交易状态
        createTimes: [appointDate(-3) + ' 00:00:00', appointDate() + ' 23:59:59'],
        complete_times: [],
        recipient_channel: '',
        app_name: ''
      },
      bankList: [],
      tableData: [],
      total_amount: 0,
      total_fee: 0,
      total_count: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      },
      detailId: '',
      downloading: false
    }
  },
  computed: {
    getFxTransactionStatusMap() {
      return function(value) {
        return fxTransactionStatusMap(value)
      }
    },
    fxTransactionStatusMap(){
      return fxTransactionStatusMap()
    },
    getFXTransactionType(){
      return function(value) {
        return fxTransactionTypeMap(value)
      }

    }
  },
  created() {
    this.handleFilter()
  },
  methods: {
    getPayoutDetailInfo(params = {}) {
      this.listLoading = true
      pageForeignExchange(params).then(res => {
        const { total, list = [], current, total_amount, total_fee } = res.data || {}
        this.listQuery.total = total
        this.listQuery.page = params.page ? params.page : 1
        this.tableData = list
        this.total_amount = total_amount
        this.total_fee = total_fee
        this.total_count = total
      }).finally(() => {
        this.listLoading = false
      })
    },

    getParams(otherParams = {}) {
      const { createTimes = [], complete_times = [], ...otherSerach  } = this.search
      let params = {
        create_start_date_time: createTimes && createTimes[0],
        create_end_date_time: createTimes && createTimes[1],
        complete_start_date_time: complete_times && complete_times[0],
        complete_end_date_time: complete_times && complete_times[1],
        ...otherParams,
        ...otherSerach
      }
      params = filterEmptyAttr(params)
      return params
    },

    handleFilter(otherParams = {}) {
      if (!this.$commonFn.checkSubmitDateLimit(this.search.createTimes, 15)) {
        this.$message.warning('The maximum date range  is limited to 15 days, please select again')
        return
      }
      if (!this.$commonFn.checkSubmitDateLimit(this.search.complete_times, 15)) {
        this.$message.warning('The maximum date range  is limited to 15 days, please select again')
        return
      }
      const params = this.getParams(otherParams)
      this.getPayoutDetailInfo(params)
    },

    onClickDetailTxt(row) {
      this.detailId = row.transaction_id
      this.showPayDetailModal()
    },

    showPayDetailModal() {
      this.$refs.fxMentDetailsModal.changModalStatus(true)
    },

    onClickDowmloadBtn() {
      if (!this.$commonFn.checkSubmitDateLimit(this.search.createTimes, 31)) {
        this.$message.warning('The maximum date range  is limited to 31 days, please select again')
        return
      }
      if (!this.$commonFn.checkSubmitDateLimit(this.search.complete_times, 31)) {
        this.$message.warning('The maximum date range  is limited to 31 days, please select again')
        return
      }
      const params = this.getParams()
      this.downloading = true
      pageForeignExchangeDownload(params).then(res => {
        const { data } = res
        if (data.is_async) {
          this.$store.commit('app/SET_SHOW_DOWNLOAD_LIST', true)
        }
      }).finally(() => {
        setTimeout(() => {
          this.downloading = false
        }, 3000)
      })
    },

    handleXlsxData(data = []) {
      const rows = [[
        this.$t('merchantAccount.merchant_order_id'),
        this.$t('customerService.transaction_id'),
        this.$t('merchantAccount.amount'),
        this.$t('merchant.service_fee'),
        this.$t('merchantAccount.recipient_name'),
        this.$t('merchantAccount.recipient_account'),
        this.$t('data.payment_method_channel'),
        this.$t('data.remitting_bank'),
        this.$t('data.remitting_account'),
        this.$t('merchantAccount.po_trans_status'),
        // this.$t('customerService.app_name'),
        this.$t('merchantAccount.create_time'),
        this.$t('merchantAccount.complete_time')
      ]]

      // const toDivideWithDot = this.$options.filters['toDivideWithDot']
      if (Array.isArray(data) && data.length > 0) {
        data.forEach((tr) => {
          rows.push([
            tr.merchant_order_id,
            tr.transaction_id,
            tr.amount,
            tr.fee,
            tr.recipient_name,
            tr.recipient_account,
            tr.receiving_channel,
            tr.remitting_bank,
            tr.remitting_account,
            tr.status,
            tr.create_time,
            tr.complete_time
          ])
        })
      }
      return Promise.resolve(rows)
    },
    onClickPaginator() {
      this.handleFilter(this.listQuery)
    },
    onClickFixedArrow() {
      this.showFilterContent = !this.showFilterContent
    },
    onClickReset() {
      this.search = {}
    }
  }
}
</script>

<style lang="scss" scoped>
.payout-trans-details{
  .transTime{
    display: inline-block;
    padding: 0 20px 10px 0;
    font-size: 14px;
    font-weight: 500;  font-family: 'Inter-Medium';
    color: #606266;
  }
  .filter-container{
    padding: 20px 0 0 20px;
  }
  .search-frame {
    width: 160px;
    margin-right: 5px;
  }
   .search-frame-order{
    width:200px;
  }
  .search-btn {
    margin-right: 10px;
  }
  .download-btn{
    margin: 0;
  }
  .picker{
    margin-right: 5px;
  }
  .mb-10{
    margin-bottom: 10px;
  }
  .detailTxt{
    font-size: 12px;
    color: #3579FF;
    text-decoration: underline;
     cursor: pointer;
  }
  .total-container{
    display: flex;
    border: 1px solid #D3D7DF;
    margin-bottom: 32px;
    .total-item{
      padding: 10px 0;
      flex: 1;
      text-align: center;
      border-right: 1px solid #D3D7DF;
      font-weight: 400;
      font-size: 14px;
      color: #4B5567;
    }
    .total-item:not(:last-child){
      border-right: 1px solid #D3D7DF;
    }
  }
  .total{
    border-top: 1px solid #D5D8DE;
    padding: 24px 24px 0 24px;
    &-title{
      font-size: 12px;
      line-height: 17px;
      color: #606266;
    }
    &-num{
      margin-top: 10px;
      padding-bottom: 20px;
      font-size: 16px;
      font-family: Source Han Sans SC;
      font-weight: bold;
      line-height: 24px;
      color: #303133;
    }
  }

}

</style>
